<div class="registerView verticalCenterView">
    <h1 class="registerView__title">Registration</h1>
    <form class="registerForm registerView__registerForm" [formGroup]="registrationForm" novalidate (ngSubmit)="onSubmit()" *ngIf="!successRegister">
        <mat-form-field class="registerForm__email">
            <mat-label>Email</mat-label>
            <input matInput
                       type="email"
                       placeholder="Email"
                       formControlName="email"
                       required />
            <mat-error *ngIf="isEmailNotValid()">
                {{ getEmailErrorMessage() }}
            </mat-error>
        </mat-form-field>

        <div class="registerForm__info primary" *ngIf="enablePhoneRegConfirm">
            For protection of our members and to curb spam we need to verify you're a real person<br>
            We will send you a one time code to your phone number
            <div style="margin-top: 10px;"><img src="assets/img/icons/mobile_icon.png" /></div>
        </div>

        <mat-form-field class="registerForm__phone">
            <mat-label>Phone</mat-label>
            <input matInput
                       type="tel"
                       placeholder="Phone"
                       formControlName="phone"
                       required />
            <mat-error *ngIf="
                registrationForm.controls['phone'].hasError('required')
                ">
                Phone is required
            </mat-error>
        </mat-form-field>

        <div class="registerForm__info">
            <strong>
                <p>We take your privacy very seriously. We don't use or disclose your phone number</p>
            </strong>
            <p>This number will be associated with this email address. You won't be able to use it twice to register another email account</p>
        </div>

        <mat-form-field class="registerForm__password">
            <mat-label>Password</mat-label>
            <input matInput
                       #password
                       type="password"
                       placeholder="Password"
                       formControlName="password"
                       required />
            <mat-error *ngIf="isPasswordNotValid()">
                {{ getPasswordErrorMessage() }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="registerForm__password">
            <mat-label>Password Confirmation</mat-label>
            <input matInput
                       #passwordConfirm
                       type="password"
                       placeholder="Password Confirmation"
                       formControlName="passwordConfirm"
                       required />
            <mat-error>
                {{ getPasswordConfirmErrorMessage() }}
            </mat-error>
        </mat-form-field>
        <div class="registerForm__disclaimer">
            <b>Adult content disclaimer</b><br>
            This website may contain nudity, adult language and explicit
            sexual content. It should be accessed only by adults over the age
            of 18 (or the age of consent in the jurisdiction from which it is
            being accessed). By accessing this website, you identify that you
            are of legal age. Any unauthorized use of this site may violate
            state, federal and/or foreign law. By clicking I AGREE, you are
            making the following statements:
            <ul>
              <li>
                I understand and agree to abide by the standards and laws of
                my community.
              </li>
              <li>
                I am at least 18 years of age, and I have the legal right to
                possess adult material in my community.
              </li>
              <li>
                I will not post any language or materials that discriminate
                based on race, color, religion, sex or national origin.
              </li>
              <li>
                By viewing any part of this website, I agree that I shall not
                hold the owners of the website or its employees responsible
                for any materials located on the site.
              </li>
              <li>
                The opinions expressed on this website are solely those of the
                advertisers. They do not purport to reflect the opinions or
                views of wickedlist.com or any of its' employees.
              </li>
              <li>
                We will send you verification code via SMS to your mobile phone.
              </li>
            </ul>
        </div>
        <mat-checkbox class="registerForm__checkTerms" formControlName="igreeDisclaimer">I Agree</mat-checkbox>  

        <mat-error class="registerForm__errorWrap" *ngIf="!formControlIsValid(registrationForm, 'igreeDisclaimer')">
            Required
        </mat-error>
        
        <div class="registerForm__captcha">
            <re-captcha (resolved)="captchaResolved($event)" *ngIf="this.captchaAvailable()"
                        [siteKey]="this.service.captchaService.getCurrentCaptchaKey()"> </re-captcha>
        </div>    

        <div class="registerView__loader" *ngIf="loading"><mat-spinner diameter="36" ></mat-spinner></div>  
        <button class="registerForm__submit" type="submit" mat-raised-button color="primary" [disabled]="loading">Submit</button>
        <div class="registerView__btBack">
            <a mat-raised-button color="primary" (click)="locationBack()">Back</a>
        </div>
    </form>
    <div class="registerView__success" *ngIf="successRegister">
        <h2>Registration Success</h2>
        <div class="registerView__loader" *ngIf="loading"><mat-spinner diameter="36" ></mat-spinner></div>  
    </div>
    
    
</div>
